var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 2000,
    viewBox: "0 0 3000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3000 0H0V2000H3000V0Z",
    fill: "url(#paint0_linear_43_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2344.5 493C2349.75 493 2354 488.747 2354 483.5C2354 478.253 2349.75 474 2344.5 474C2339.25 474 2335 478.253 2335 483.5C2335 488.747 2339.25 493 2344.5 493Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534.5 397C2539.75 397 2544 392.747 2544 387.5C2544 382.253 2539.75 378 2534.5 378C2529.25 378 2525 382.253 2525 387.5C2525 392.747 2529.25 397 2534.5 397Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2881.5 332C2886.75 332 2891 327.747 2891 322.5C2891 317.253 2886.75 313 2881.5 313C2876.25 313 2872 317.253 2872 322.5C2872 327.747 2876.25 332 2881.5 332Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M2942.5 301C2947.75 301 2952 296.747 2952 291.5C2952 286.253 2947.75 282 2942.5 282C2937.25 282 2933 286.253 2933 291.5C2933 296.747 2937.25 301 2942.5 301Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2952.5 67C2957.75 67 2962 62.7467 2962 57.5C2962 52.2533 2957.75 48 2952.5 48C2947.25 48 2943 52.2533 2943 57.5C2943 62.7467 2947.25 67 2952.5 67Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570.5 76C2575.75 76 2580 71.7467 2580 66.5C2580 61.2533 2575.75 57 2570.5 57C2565.25 57 2561 61.2533 2561 66.5C2561 71.7467 2565.25 76 2570.5 76Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2502.5 159C2507.75 159 2512 154.747 2512 149.5C2512 144.253 2507.75 140 2502.5 140C2497.25 140 2493 144.253 2493 149.5C2493 154.747 2497.25 159 2502.5 159Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2247.5 154C2252.75 154 2257 149.747 2257 144.5C2257 139.253 2252.75 135 2247.5 135C2242.25 135 2238 139.253 2238 144.5C2238 149.747 2242.25 154 2247.5 154Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2064.5 310C2069.75 310 2074 305.747 2074 300.5C2074 295.253 2069.75 291 2064.5 291C2059.25 291 2055 295.253 2055 300.5C2055 305.747 2059.25 310 2064.5 310Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1867.5 202C1872.75 202 1877 197.747 1877 192.5C1877 187.253 1872.75 183 1867.5 183C1862.25 183 1858 187.253 1858 192.5C1858 197.747 1862.25 202 1867.5 202Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1274.5 137C1277.54 137 1280 134.538 1280 131.5C1280 128.462 1277.54 126 1274.5 126C1271.46 126 1269 128.462 1269 131.5C1269 134.538 1271.46 137 1274.5 137Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1823.5 332C1828.75 332 1833 327.747 1833 322.5C1833 317.253 1828.75 313 1823.5 313C1818.25 313 1814 317.253 1814 322.5C1814 327.747 1818.25 332 1823.5 332Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1160.5 272C1165.75 272 1170 267.747 1170 262.5C1170 257.253 1165.75 253 1160.5 253C1155.25 253 1151 257.253 1151 262.5C1151 267.747 1155.25 272 1160.5 272Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.5 212C759.747 212 764 207.747 764 202.5C764 197.253 759.747 193 754.5 193C749.253 193 745 197.253 745 202.5C745 207.747 749.253 212 754.5 212Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M129.5 172C134.747 172 139 167.747 139 162.5C139 157.253 134.747 153 129.5 153C124.253 153 120 157.253 120 162.5C120 167.747 124.253 172 129.5 172Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M466.5 502C471.194 502 475 498.194 475 493.5C475 488.806 471.194 485 466.5 485C461.806 485 458 488.806 458 493.5C458 498.194 461.806 502 466.5 502Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M643.5 557C648.194 557 652 553.194 652 548.5C652 543.806 648.194 540 643.5 540C638.806 540 635 543.806 635 548.5C635 553.194 638.806 557 643.5 557Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M512.5 657C517.194 657 521 653.194 521 648.5C521 643.806 517.194 640 512.5 640C507.806 640 504 643.806 504 648.5C504 653.194 507.806 657 512.5 657Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.5 665C164.194 665 168 661.194 168 656.5C168 651.806 164.194 648 159.5 648C154.806 648 151 651.806 151 656.5C151 661.194 154.806 665 159.5 665Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 1026C190.194 1026 194 1022.19 194 1017.5C194 1012.81 190.194 1009 185.5 1009C180.806 1009 177 1012.81 177 1017.5C177 1022.19 180.806 1026 185.5 1026Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.5 934C483.194 934 487 930.194 487 925.5C487 920.806 483.194 917 478.5 917C473.806 917 470 920.806 470 925.5C470 930.194 473.806 934 478.5 934Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M308.5 692C315.404 692 321 686.404 321 679.5C321 672.596 315.404 667 308.5 667C301.596 667 296 672.596 296 679.5C296 686.404 301.596 692 308.5 692Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.5 1367C73.4036 1367 79 1361.4 79 1354.5C79 1347.6 73.4036 1342 66.5 1342C59.5964 1342 54 1347.6 54 1354.5C54 1361.4 59.5964 1367 66.5 1367Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M418 411C420.761 411 423 408.761 423 406C423 403.239 420.761 401 418 401C415.239 401 413 403.239 413 406C413 408.761 415.239 411 418 411Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2804.5 135C2809.75 135 2814 130.747 2814 125.5C2814 120.253 2809.75 116 2804.5 116C2799.25 116 2795 120.253 2795 125.5C2795 130.747 2799.25 135 2804.5 135Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2682.5 785C2687.75 785 2692 780.747 2692 775.5C2692 770.253 2687.75 766 2682.5 766C2677.25 766 2673 770.253 2673 775.5C2673 780.747 2677.25 785 2682.5 785Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2839.5 804C2844.75 804 2849 799.747 2849 794.5C2849 789.253 2844.75 785 2839.5 785C2834.25 785 2830 789.253 2830 794.5C2830 799.747 2834.25 804 2839.5 804Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_2",
    x1: 1272,
    y1: 100.5,
    x2: 1780.5,
    y2: 1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192848"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 2000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.8475053b145efdbfcbc0121b0f9bcac6.svg";
export { ForwardRef as ReactComponent };